import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'img[appImageFallback]',
    standalone: false,
})
export class ImageFallbackDirective {
    @Input() appImageFallback = '/v2/assets/images/default.png';

    private hasAppliedFallback = false;

    constructor(private readonly elementRef: ElementRef<HTMLImageElement>) {}

    @HostListener('error')
    loadFallbackOnError() {
        if (this.hasAppliedFallback) {
            return;
        }

        const element: HTMLImageElement = this.elementRef.nativeElement;
        element.src = this.appImageFallback;
        this.hasAppliedFallback = true;
    }
}
